<!-- mobile-logo -->

    <img src="assets/images/logo.png" style="width: 80%">
